import { links } from '@app/router';

export default function staticlink(string: string): string {
    return `${links.wiki}/${string}`;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/modules/shared/filters/staticlink.ts